export const config = {
	playStoreLink: "https://play.google.com/store/apps/details?id=com.wird.app",
	appStoreLink: "https://apps.apple.com/us/app/wird-%D9%88-%D8%B1%D8%AF/id1616045832",
	appGalleryLink: "",
};
